// src/App.jsx
import "./App.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Category from "./pages/Category";
import Product from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import ShippingPolicy from "./pages/ShippingPolicy";
import Brands from "./pages/Brands";
import BrandPage from "./pages/BrandPage";
import Search from "./pages/Search";
import AdminProducts from "./pages/AdminProducts";
import LoginPage from "./pages/LoginPage";

import PrivateRoute from "./routes/PrivateRoute";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./auth/AuthContext";

/* Scroll to top on route change */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

/* Simple 404 */
function NotFound() {
  return (
    <main className="mx-auto max-w-4xl px-4 py-16">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="mt-2 text-slate-600">
        The page you’re looking for doesn’t exist.
      </p>
      <a
        href="/"
        className="inline-block mt-4 rounded-lg border px-4 py-2 hover:bg-slate-50"
      >
        Go home
      </a>
    </main>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        {/* Router is in index.jsx */}
        <ScrollToTop />
        <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col">
          <Header />
          <div className="flex-1">
            <Routes>
              {/* Public pages */}
              <Route path="/" element={<Home />} />
              <Route path="/sneakers" element={<Category />} />
              <Route path="/men-shoes" element={<Category />} />
              <Route path="/women-shoes" element={<Category />} />
              <Route path="/kids-shoes" element={<Category />} />
              <Route path="/sport-shoes" element={<Category />} />
              <Route path="/boots" element={<Category />} />
              <Route path="/official-shoes" element={<Category />} />
              <Route path="/slip-on-shoes" element={<Category />} />
              <Route path="/product/:slug" element={<Product />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} /> {/* ✅ */}
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/brand/:slug" element={<BrandPage />} />
              <Route path="/search" element={<Search />} />

              {/* Login */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected admin page */}
              <Route
                path="/admin/products"
                element={
                  <PrivateRoute>
                    <AdminProducts />
                  </PrivateRoute>
                }
              />

              {/* Redirects / 404 */}
              <Route
                path="/admin"
                element={<Navigate to="/admin/products" replace />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}
